import type { SyntheticEvent } from 'react';

/** Сохраняет событие и располагает меню у кнопки при открытии клавиатурой */
export const getContextMenuEvent = (event: SyntheticEvent): SyntheticEvent => {
    const bounds = event.currentTarget instanceof Element
        ? event.currentTarget.getBoundingClientRect()
        : null;

    const x: unknown = Reflect.get(event, 'pageX');
    const y: unknown = Reflect.get(event, 'pageY');

    return Object.assign({}, event, {
        pageX: typeof x === 'number' && x > 0
            ? x
            : (bounds?.left ?? 0) + window.scrollX,
        pageY: typeof y === 'number' && y > 0
            ? y
            : (bounds?.bottom ?? 0) + window.scrollY,
        preventDefault: () => event.preventDefault(),
        stopPropagation: () => event.stopPropagation(),
    });
};
